import React from 'react';
import './Zoddetails.css';

const services = [
  {
    title: 'Sod Removal & Site Prep',
    text: `We remove old grass, weeds, and debris, then shape and level the sub-grade for proper drainage. Edges are cleaned, utilities are marked, and the base is compacted to create a stable foundation for your new lawn.`,
  },
  {
    title: 'Topsoil & Grading',
    text: `We add fresh topsoil where needed and fine-grade the surface to the correct pitch so water flows away from structures. This prepares a nutrient-rich, even bed that helps new sod root quickly and uniformly.`,
  },
  {
    title: 'Sod Delivery & Installation',
    text: `Premium, fresh-cut sod is delivered and installed with tight seams and clean edges. We stagger joints for a natural look, trim precisely around borders and features, and roll the surface to ensure full contact with the soil.`,
  },
  {
    title: 'Watering & Lawn Care Setup',
    text: `After installation, we water thoroughly and outline a simple watering schedule for the first critical weeks. We share mowing and traffic guidelines so the lawn establishes safely and thrives long-term.`,
  },
];

export default function Zoddetails() {
  return (
    <section className="zoddetails">
      <div className="zoddetails__container">
        <header className="zoddetails__header">
          <h2 className="zoddetails__title">
            Sod Installation: Our Step-by-Step Process
          </h2>
             <div className="rl-title-underline"></div>
          <p className="zoddetails__subtitle">
            We handle the full sod installation process, including removal, grading, laying, and initial care to support healthy establishment.
          </p>
        </header>

        <div className="zoddetails__grid">
          {services.map(({ title, text }) => (
            <article key={title} className="zoddetails__card">
              <div className="zoddetails__card-content">
                <h2 className="zoddetails__card-title">{title}</h2>
                <p className="zoddetails__card-text">{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
